import {
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  Table,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import FileDownloadIcon from "@material-ui/icons/GetApp";
import React, { useState } from "react";
import PaginationTable from "../../paginationTable";
import { CouponTypes, WowcherCoupon } from "../../../../types/coupons";
import { getCouponStatus } from "../../../../helpers/getCouponStatus";
import { getDate } from "../../../../helpers/dateHelper";
import HeadTable from "../../sortTable/sortTable";
import TablesSearch from "../../tablesSearch/tablesSearch";
import CheckBoxesFilter from "../../checkboxFilter";
import DateFilter from "../../../users/DateFilter";
import { FilterDate } from "../../../../types/commonForm";

import "./couponsWowcherTableStyles.css";

interface Props {
  coupons: Array<WowcherCoupon>;
  page: number;
  perPage: number;
  collectionLength: number;
  total: number;
  isView: boolean;
  handleShowViewModal: (couponId: string | undefined) => void;
  handleShowDeleteModal: (couponId: string | undefined) => void;
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => void;
  handleLastPage: () => void;
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleFirstPage: () => void;
  handleSort: (direction: string, title: string) => void;
  applySearch: (field: string) => void;
  statusFilterValues: any;
  checkStatusFilter: (event: React.ChangeEvent<HTMLInputElement>) => void;
  applyStatusFilter: () => void;
  clearStatusFilter: () => void;
  search: (value: string, field: string) => void;
  clearSearch: (field: string) => void;
  searchValue: string;
}

export const CouponsWowcherTable = ({
  coupons,
  page,
  perPage,
  collectionLength,
  total,
  handleShowViewModal,
  handleChangePage,
  handleLastPage,
  handleChangeRowsPerPage,
  handleFirstPage,
  handleShowDeleteModal,
  isView,
  handleSort,
  applySearch,
  statusFilterValues,
  checkStatusFilter,
  applyStatusFilter,
  clearStatusFilter,
  search,
  clearSearch,
  searchValue,
}: Props) => {
  const [dropdown, setDropdown] = useState({
    couponId: false,
    status: false,
  });

  const filterDropdown = (title: string) => {
    setDropdown({ ...dropdown, [title]: !dropdown[title] });
  };

  const closeFilter = () => {
    setDropdown({
      couponId: false,
      status: false,
    });
  };

  return (
    <>
      <TableContainer className="couponTableWrapper">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell key={1}>
                <HeadTable
                  title="#"
                  sort={(direction, field) => handleSort(direction, "couponId")}
                  filterHandle={() => filterDropdown("couponId")}
                />
                {dropdown.couponId && (
                  <TablesSearch
                    search={(event) =>
                      search(event.currentTarget.value, "couponId")
                    }
                    applySearch={() => applySearch("couponId")}
                    searchString={searchValue}
                    clearSearch={() => clearSearch("couponId")}
                  />
                )}
              </TableCell>
              <TableCell>Price, £</TableCell>
              <TableCell>Num of Tickets</TableCell>
              <TableCell className="status-column">
                <HeadTable
                  title="Status"
                  sort={(direction, field) => handleSort(direction, "status")}
                  filterHandle={() => filterDropdown("status")}
                />
                {dropdown.status && (
                  <CheckBoxesFilter
                    names={["Active", "Used"]}
                    applyFilter={applyStatusFilter}
                    clearSelectedItem={clearStatusFilter}
                    filterValues={statusFilterValues}
                    checkFilter={checkStatusFilter}
                  />
                )}
              </TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody onClick={closeFilter}>
            {coupons.length > 0 &&
              coupons.map((coupon) => {
                return (
                  <TableRow key={coupon._id}>
                    <TableCell>{coupon.couponId}</TableCell>
                    <TableCell>{coupon.price}</TableCell>
                    <TableCell>{coupon.value}</TableCell>
                    <TableCell>{coupon.userEmail ? "Used" : "Active"}</TableCell>
                    <TableCell className="actions-table-cell">
                      <div className="actions-table-body">
                        <VisibilityIcon
                          onClick={() => handleShowViewModal(coupon._id)}
                          id="show-tickets"
                        />

                        {!isView && (
                          <div
                            onClick={() => handleShowDeleteModal(coupon._id)}
                          >
                            <DeleteForeverIcon className="delete-icon" />
                          </div>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginationTable
        page={page}
        perPage={perPage}
        collectionLength={collectionLength}
        total={total}
        handleChangePage={handleChangePage}
        handleLastPage={handleLastPage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleFirstPage={handleFirstPage}
        title="Coupons"
      />
    </>
  );
};
